import { cn } from '@/lib/utils/utils';
import { type LucideIcon } from 'lucide-react';
import { type ReactNode } from 'react';
import { insightBlurClass } from '@/features/jobs/lib/insightBlurClass';

export function InsightMetricColumn({
  label,
  icon: Icon,
  blurred,
  children,
}: {
  label: string;
  icon: LucideIcon;
  blurred: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'min-w-0',
        blurred && insightBlurClass
      )}
      aria-hidden={blurred}
    >
      <div className="mb-1 flex items-center gap-1 text-xs text-gray-500">
        <Icon className="h-3.5 w-3.5 shrink-0" />
        {label}
      </div>
      {children}
    </div>
  );
}
